const normalize = (str) => (str || '').toLowerCase().trim();

const getRelevanceScore = (name, query) => {
  if (!query) return 0;
  if (name === query) return 0;
  if (name.startsWith(query)) return 1;
  if (name.split(/\s+/).some((word) => word.startsWith(query))) return 2;
  if (name.includes(query)) return 3;
  return 4;
};

/**
 * Filter items by whether every whitespace-separated word in `searchTerm`
 * appears in the item's name, then sort matches by how directly the name
 * corresponds to the full trimmed query (exact -> starts-with -> word-boundary
 * -> substring). Alphabetical within each tier. Empty query skips sorting.
 */
const searchByRelevance = (items, searchTerm, getName = (obj) => obj.name) => {
  const query = normalize(searchTerm);
  const searchWords = query.split(/\s+/);

  const filtered = (items || []).filter((obj) => {
    const name = normalize(getName(obj));
    return searchWords.every((word) => name.includes(word));
  });

  if (!query) return filtered;

  return [...filtered].sort((a, b) => {
    const nameA = normalize(getName(a));
    const nameB = normalize(getName(b));
    const scoreA = getRelevanceScore(nameA, query);
    const scoreB = getRelevanceScore(nameB, query);
    if (scoreA !== scoreB) return scoreA - scoreB;
    return nameA.localeCompare(nameB);
  });
};

export default searchByRelevance;
